import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'
import classnames from 'classnames'

import { loadEventTypes, loadSetupform, updateSetupformBasicDetails } from 'actions/setupform'
import { getNewVenue, isVoucher } from 'selectors/setupform'
import SetupformBreadcrumbProgress, { BREADCRUMB_BASIC_DETAILS } from 'components/setupform-breadcrumb-progress'
import ErrorMessage from 'components/error-message'
import {
  SetupformEventFormContainer,
  SetupformVoucherFormContainer
} from 'components/setupform-form/setupform-form-container'
import { getPartnerUrl } from 'utils/urls'

import styles from './setupform-page.css'

import TimeOutLogo from '../../../assets/icons/to-logo-black.svg'
import ArrowRightIcon from '../../../assets/icons/arrow-right.svg'

export class SetupformPage extends Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentWillMount() {
    this.props.loadEventTypes()
    this.props.loadSetupform(this.props.setupformId)
  }

  onSubmit(values) {
    return new Promise((resolve, reject) => {
      this.props.updateSetupformBasicDetails(
        this.props.setupformId, { ...values, newVenue: this.props.newVenue }, resolve, reject
      )
    })
  }

  handleSubmit() {
    this.setupformForm.submit()
  }

  render() {
    const FormComponent = this.props.isVoucher
      ? SetupformVoucherFormContainer
      : SetupformEventFormContainer

    return (
      <DocumentTitle title={'Ecommerce Portal - Time Out - Setupform'}>
        <div styleName="page">
          <div styleName="header">
            <a href={getPartnerUrl(this.props.partnerId)}>
              <div styleName="logo">
                <TimeOutLogo styleName="logo-icon" />
              </div>
            </a>
            <SetupformBreadcrumbProgress
              isVoucher={this.props.isVoucher}
              currentStep={BREADCRUMB_BASIC_DETAILS}
            />
            <button
              disabled={this.props.submitting}
              styleName={classnames('next', { 'next-submitting': this.props.submitting })}
              onClick={this.handleSubmit}
            >
              Next <ArrowRightIcon styleName="next-icon" />
            </button>
          </div>
          <ErrorMessage isFixed isSmall />
          <RelayoutWrapper>
            <Relayout align="center">
              <RelayoutItem sm="10">
                <FormComponent
                  ref={(c) => { this.setupformForm = c }}
                  setupformId={this.props.setupformId}
                  onSubmit={this.onSubmit}
                />
              </RelayoutItem>
            </Relayout>
          </RelayoutWrapper>
        </div>
      </DocumentTitle>
    )
  }
}

SetupformPage.propTypes = {
  loadEventTypes: PropTypes.func,
  loadSetupform: PropTypes.func,
  partnerId: PropTypes.string,
  newVenue: PropTypes.object,
  setupformId: PropTypes.string,
  updateSetupformBasicDetails: PropTypes.func,
  submitting: PropTypes.bool,
  isVoucher: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
  const { partnerId, setupformId } = ownProps.params

  return {
    partnerId,
    setupformId,
    setupformPurchaseType: state.entities.setupforms
      && state.entities.setupforms[setupformId]
      && state.entities.setupforms[setupformId].purchaseType,
    submitting: state.form.setupform && state.form.setupform._submitting, // eslint-disable-line no-underscore-dangle
    newVenue: getNewVenue(state),
    isVoucher: isVoucher(setupformId)(state),
  }
}

const mapDispatchToProps = {
  loadEventTypes,
  loadSetupform,
  updateSetupformBasicDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SetupformPage, styles, { allowMultiple: true }))



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-page/setupform-page.js
 **/